import React, { useState } from 'react';
import {
  Unstable_Grid2 as Grid,
  Button as MuiButton,
  TextField,
  InputAdornment,
} from '@mui/material';
import { AuthButton, Combo, Dialog } from '../../../../Components/MUIs';
import { Search as SearchIcon } from '@mui/icons-material';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { getColumnDefs1, getColumnDefsModal } from './AUT_BASIC_ColumnDefs';

function AUT_BASIC(props) {
  const [modalToggle2, setModalToggle2] = useState(false);

  const popupClickEvent1 = (_data) => {
    props.setClickRowId(_data.node.id);
    props.SearchLogic2();
  };

  const columnDefs = getColumnDefs1({
    ...props,
    popupClickEvent1,
  });
  const columnDefsModal = getColumnDefsModal();

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Auth"
          printYn="N"
          saveClick={() => props.SaveLogic1?.()}
          searchClick={(e) => {
            props.gridRef1?.current?.api?.setQuickFilter(e);
          }}
          conditions={[
            {
              type: 'combo',
              fullWidth: false,
              value: props.comboAuth.authVal,
              onChange: (e) => {
                props.handleAuthComboChange?.(e);
              },
              items: props.comboAuth.comboList,
              title: '상세권한',
              name: '상세권한',
            },
            {
              type: 'button',
              name: '복사',
              onClick: () => {
                props.setComboAuth2({
                  ...props.comboAuth2,
                  authVal: '0',
                });
                setModalToggle2(true);
              },
            },
          ]}
          grids={
            <BusinessGridCommon
              getRowId={(params) => String(params.data?.no ?? '')}
              gridRef={props.gridRef1}
              editable={true}
              columnDefs={columnDefs}
              rowData={props.rowData1}
              setSelectedRowData={props.setSelectedRowData1}
              setChangedRowData={props.setChangedRowData1}
              refreshClick1={() => props.SearchLogic1?.()}
              addClick1={() => {
                GridFunctions.addClick(
                  props.gridRef1,
                  {
                    SAVE_YN: 'N',
                    DELETE_YN: 'N',
                    PRINT_YN: 'N',
                  },
                  {}
                );
              }}
              deleteClick1={() => props.DeleteClick1?.()}
            />
          }
        />
      </Grid>
      {props.modalToggle1 && (
        <Dialog
          title={'MENU ID 설정'}
          open={props.modalToggle1}
          onClose={() => props.setModalToggle1(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName={'선택'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={true}
          onSave={() => {
            if (props.gridRef1.current) {
              const rowNode = props.gridRef1.current.api.getRowNode(
                props.clickRowId
              );
              if (
                rowNode &&
                props.selectedModalRowData &&
                props.selectedModalRowData[0]
              ) {
                rowNode.setDataValue(
                  'PRO_ID',
                  props.selectedModalRowData[0].PRO_ID
                );
                rowNode.setDataValue(
                  'PRO_CONTENT',
                  props.selectedModalRowData[0].PRO_CONTENT
                );
              }
            }
          }}
          maxWidth="lg"
          content={
            <React.Fragment>
              <TextField
                placeholder="검색"
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    paddingRight: 0,
                  },
                  mb: 1,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ height: '100%' }}>
                      <MuiButton
                        edge="end"
                        size="small"
                        sx={{
                          borderLeft: 1,
                          borderColor: 'divider',
                          color: 'rgba(0, 0, 0, 0.54)',
                        }}
                        style={{
                          padding: '0px',
                          borderRadius: '0px',
                          borderTopRightRadius: '8px',
                          borderBottomRightRadius: '8px',
                        }}
                        onClick={() =>
                          props.gridRef2.current?.api?.setQuickFilter(
                            props.modalText1
                          )
                        }
                      >
                        <SearchIcon sx={{ m: 0 }} style={{ margin: '0px' }} />
                      </MuiButton>
                    </InputAdornment>
                  ),
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    props.gridRef2.current?.api?.setQuickFilter(
                      props.modalText1
                    );
                  }
                }}
                value={props.modalText1}
                onChange={(e) => props.setModalText1(e.target.value)}
              />
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '700px', width: '100%' }}
              >
                <AgGridReact
                  ref={props.gridRef2}
                  animationRows={true}
                  columnDefs={columnDefsModal}
                  rowData={props.modalRowData}
                  defaultColDef={{
                    cellDataType: false,
                    minWidth: 100,
                    editable: true,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                  }}
                  rowSelection="single"
                  onSelectionChanged={() => {
                    GridFunctions.onSelectionChanged(
                      props.gridRef2,
                      (_selected) => {
                        props.setSelectedModalRowData(_selected);
                      }
                    );
                  }}
                  getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
              </div>
            </React.Fragment>
          }
        />
      )}
      {modalToggle2 && (
        <Dialog
          title={'복사할 항목을 고르세요.'}
          open={modalToggle2}
          onClose={() => setModalToggle2(false)}
          contentSx={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          saveButtonName={'복사하기'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={true}
          onSave={() => {
            if (props.gridRef1.current) {
              props.gridRef1.current.api.setRowData(props.modalRowData2);
              const rowData = [];
              props.gridRef1.current.api.forEachNode((node) => {
                rowData.push({ ...node.data, i: node.id });
              });
              props.setChangedRowData1(rowData);
            } else {
              props.setRowData1(props.modalRowData2);
            }
            setModalToggle2(false);
          }}
          maxWidth="xs"
          content={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Combo
                value={props.comboAuth2.authVal}
                onChange={(e) => {
                  props.setComboAuth2({
                    ...props.comboAuth2,
                    authVal: e,
                  });
                  props.SearchLogic3(e);
                }}
                items={props.comboAuth.comboList.filter(
                  (item) => item.value !== props.comboAuth.authVal
                )}
                size="small"
                fullWidth
              />
            </div>
          }
        />
      )}
    </Grid>
  );
}

export default AUT_BASIC;
